// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"936":"d7a06dce","9984":"a3fce9e6"}[chunkId] + ".chunk.css";
};